import { makeStyles } from '@material-ui/core';
import { rgba } from 'polished';

import { Comet } from 'styles/colors';

export default makeStyles({
  cardWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 32,
  },
  time: {
    fontSize: 12,
    color: rgba(Comet, 0.5),
    fontFamily: 'RobotoMono, sans-serif',
  },
  card: {
    position: 'relative',
    minHeight: 120,
    flex: 1,
    marginLeft: 16,
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderLeft: ({ inspectorColor }) => `1px solid ${inspectorColor}`,
    backgroundColor: ({ inspectorColor }) => rgba(inspectorColor, 0.05),
    '&::after': {
      position: 'absolute',
      content: '""',
      width: '100%',
      bottom: -16,
      left: 0,
      borderBottom: `1px dashed ${rgba(Comet, 0.15)}`,
    },
  },
  contentLine: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  address: {
    color: ({ inspectorColor }) => inspectorColor,
    fontSize: 14,
    fontWeight: 600,
    flex: 1,
  },
  timeRange: {
    color: ({ inspectorColor }) => inspectorColor,
    fontSize: 12,
    fontFamily: 'RobotoMono, sans-serif',
  },
  client: {
    color: ({ inspectorColor }) => inspectorColor,
    fontSize: 14,
    fontWeight: 600,
    flex: 1,
  },
  rightInfoWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  inspectorsWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  inspectorsAvatarWrapper: {
    display: 'flex',
    alignItems: 'center',
    height: 48,
  },
  inspectorsTitle: {
    color: ({ inspectorColor }) => inspectorColor,
    fontSize: 14,
    fontWeight: 600,
    paddingRight: 8,
  },
  inspectorsPrimaryName: {
    color: ({ inspectorColor }) => inspectorColor,
    fontSize: 14,
    paddingRight: 2,
    marginLeft: 2,
  },
  inspectorAvatar: {
    border: ({ inspectorColor }) => `1px solid ${inspectorColor}`,
    borderRadius: '50%',
    width: 48,
    height: 48,
    objectFit: 'cover',
    marginLeft: 4,
  },
  defaultAvatar: {
    width: 26,
    height: 26,
    marginLeft: 4,
  },
  reports: {
    color: ({ inspectorColor }) => inspectorColor,
    fontSize: 14,
    fontWeight: 600,
    paddingLeft: 24,
  },
});
